var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('Search',{attrs:{"title":_vm.title,"url":_vm.url,"allowFields":_vm.$lang.userParvandehListFields,"visibleAdd":false,"showFilterBtn":false,"visibleSettings":false,"visibleExport":false,"dataNotExist":_vm.$lang.notRecordExist,"dynamicButtons":_vm.buttons,"operationField":_vm.$lang.operation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }